// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { themr } from "react-css-themr";
import { Switch, Redirect, Route } from "react-router-dom";
import { withRouter } from "react-router";
import { withApollo } from "react-apollo";
import classnames from "classnames";
import { PrivateRoute } from "@lifepay/rc-ui-toolkit";

// ABSOLUTE PATH IMPORTS
// importing object with action creator functions
import { LOCK_KEYS } from "accessConfig";
import actions from "model/actions";
import selectors from "model/selectors";

import CacheSpinner from "components/layout/CacheSpinner";
import FrontPage from "./pages/FrontPage";
import InsufficientPriviledges from "./pages/InsufficientPriviledges";
import ClientWorkflow from "./pages/workflow-client/Workflow";
import ProcessingWorkflow from "./pages/workflow-processing/Workflow";
import AdminWorkflow from "./pages/workflow-admin/Workflow";
import IncomingCall from "./pages/IncomingCall";

// RELATIVE PATH IMPORTS
// importing default component styles

@withApollo
@withRouter
@connect(
  // mapStateToProps function - passes data from store's state.
  (state) => {
    return {
      cacheRestored: selectors.app.cacheRestored$$(state),
      roles: selectors.user.roles$$(state),
      clientPrivileges: selectors.clients.currentClientPrivileges$$(state),
      canViewCallcenterWorkflow: selectors.access.getLockState(
        state,
        LOCK_KEYS.CALLCENTER_WORKFLOW_ACCESS
      ),
      canViewProcessingWorkflow: selectors.access.getLockState(
        state,
        LOCK_KEYS.PROCESSING_WORKFLOW_ACCESS
      ),
      canViewAdminWorkflow: selectors.access.getLockState(
        state,
        LOCK_KEYS.ADMIN_WORKFLOW_ACCESS
      ),
    };
  },
  // mapDispatchToProps object - pass individual action creators here
  {
    setPrivileges: actions.clients.setPrivileges,
  }
)
@themr("private")
export default class Private extends Component {
  static propTypes = {
    theme: PropTypes.object,
    cacheRestored: PropTypes.bool,
    canViewCallcenterWorkflow: PropTypes.bool,
    canViewProcessingWorkflow: PropTypes.bool,
    canViewAdminWorkflow: PropTypes.bool,
    // action creators:
    setPrivileges: PropTypes.func,
  };

  setPrivileges = (privileges) => {
    this.props.setPrivileges({ privileges });
  };

  render() {
    const {
      theme,
      cacheRestored,
      canViewCallcenterWorkflow,
      canViewProcessingWorkflow,
      canViewAdminWorkflow,
    } = this.props;

    return (
      <div className={classnames(theme.app)}>
        <CacheSpinner spin={!cacheRestored}>
          <IncomingCall />
          <Switch>
            <Route exact path="/" component={FrontPage} />
            <PrivateRoute
              path="/client"
              render={() => <ClientWorkflow />}
              auth={canViewCallcenterWorkflow}
              redirect={"/forbidden"}
              reason={{
                targetName: "интерфейсу колцентра",
                message:
                  "в профиле пользователя отсутствует роль права доступа к работе с клиентами",
              }}
            />
            <PrivateRoute
              path="/processing"
              component={ProcessingWorkflow}
              auth={canViewProcessingWorkflow}
              redirect={"/forbidden"}
              reason={{
                targetName: "интерфейсу процессинга",
                message:
                  "в профиле пользователя отсутствует права доступа к процессингу",
              }}
            />
            <PrivateRoute
              path="/admin"
              component={AdminWorkflow}
              auth={canViewAdminWorkflow}
              redirect={"/forbidden"}
              reason={{
                targetName: "панели администрирования",
                message:
                  "в профиле пользователя отсутствуют административные привелегии",
              }}
            />
            <Route
              exact
              path="/forbidden"
              component={InsufficientPriviledges}
            />
            <Route path="*" render={() => <Redirect to={`/`} />} />
          </Switch>
        </CacheSpinner>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/Private.js